// import CLSLogger from '@tencent/nb-cls-logger';
// import getCookie from './cookie';
// import Url from './url';

const Logger = {
  uplogNow: () => {},
  uplog: () => {},
};

Logger.sendWarn = function (msg = '', data = {}) {
  // this.uplogNow('WARN', msg, data);
};

Logger.sendError = function (msg = '', data = {}) {
  // this.uplogNow('ERROR', msg, data);
};

Logger.sendLogicError = function (code, model, msg = '', args = {}) {
  // const page = Url.getPage();
  // this.uplogNow('ERROR', msg, {
  //   logType: 'logic',
  //   errCode: code,
  //   model,
  //   page,
  //   args: {
  //     ...args,
  //     Page: page,
  //   },
  // });
};

Logger.sendLogicWarn = function (code, model, msg = '', args = {}) {
  // const page = Url.getPage();
  // this.uplogNow('WARN', msg, {
  //   logType: 'logic',
  //   errCode: code,
  //   model,
  //   page,
  //   args: {
  //     ...args,
  //     Page: page,
  //   },
  // });
};

Logger.sendLogicInfo = function (model = '', msg = '', args = {}) {
  // const page = Url.getPage();
  // this.uplogNow('INFO', msg, {
  //   logType: 'logic',
  //   model,
  //   page,
  //   args: {
  //     ...args,
  //     Page: page,
  //   },
  // });
};

Logger.sendLogicInfoIdle = function (model = '', msg = '', args = {}) {
  // const page = Url.getPage();
  // this.uplog('INFO', msg, {
  //   logType: 'logic',
  //   model,
  //   page,
  //   args: {
  //     ...args,
  //     Page: page,
  //   },
  // });
};

export default Logger;
